import React from 'react';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import styled from 'styled-components';

const fetchTags = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/tags/list`);
    return response.data?.payload?.tags;
};

const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    & h6 {
        color: #2c5530;
    }
    & p {
        font-size: 0.9rem;
        color: #333;
    }
`;

const TagLink = styled.a`
    display: inline-block;
    padding: 4px 8px;
    margin: 2px;
    background-color: ${props => props.$isActive ? '#2c5530' : '#f0f0f0'};
    color: ${props => props.$isActive ? '#fff' : '#333'};
    text-decoration: none;
    border-radius: 4px;
    font-size: 0.9rem;
    
    &:hover {
        background-color: #2c5530;
        color: #fff;
        text-decoration: none;
    }
`;


const TagsDiv = styled.div`
    margin-bottom: 5rem;
    margin-left: 15px;
    & h6 {
        font-size: 1.3rem;
        color: #2a5934;
        font-weight: 700;
        font-family: "Roboto slab", serif;
    }
    & p {
        font-size: 0.8rem;
        background: #9c9;
        color: #2a5934;
        padding: 1rem;
        border-radius: 5px;
        font-family: "Poppins";
        font-weight: 700;
    }
`;

export const GenericSideBarTags = ({ tagLinkStem, tagsToPreselect }) => {

    const { data: tags = [] } = useQuery({
        queryKey: ['tags'],
        queryFn: fetchTags,
    });

    const isTagSelected = (tagId) => {
        return tagsToPreselect?.some(tag => tag.id === tagId);
    };

    return (
        <TagsDiv>
                <h6>TAGS</h6>
                <p>Please select a tag to filter the list.</p> 
                <TagsContainer>
                {tags.map((tag) => (
                    <TagLink
                        href={`${tagLinkStem}/${tag.id}/${tag.name}`}
                        key={tag.id}
                        $isActive={isTagSelected(tag.id)}
                    >
                        {tag.name}
                    </TagLink>
                ))}
            </TagsContainer>
        </TagsDiv>
    )
}
